import { render, staticRenderFns } from "./order.vue?vue&type=template&id=de9fc214&scoped=true"
import script from "./order.vue?vue&type=script&lang=js"
export * from "./order.vue?vue&type=script&lang=js"
import style0 from "./order.vue?vue&type=style&index=0&id=de9fc214&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de9fc214",
  null
  
)

export default component.exports